<template>
    <div>
        <v-layout wrap>
            <v-container fluid>
                <v-layout row child-flex wrap>
                    <v-flex d-flex xs2 sm1 class="grey lighten-2">
                        <div class="text-center">
                            <h3 class="primary-color">1</h3>
                        </div>
                    </v-flex>
                    <v-flex d-flex xs10 sm11 class="grey lighten-3">
                        <div>
                            <h3 class="primary-color">Cliente</h3>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm6 class="form-group">
                <v-text-field label="Nome"
                              v-model="projeto.cliente.nome"
                              :counter="50"
                              :rules="nameRules"
                              required></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="form-group">
                <v-text-field label="CPF/CNPJ"
                              v-model="projeto.cliente.documento"
                              :rules="cpfCnpjRules"
                              v-mask-cpfCnpj
                              required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 class="form-group">
                <v-text-field label="E-mail"
                              v-model="projeto.cliente.email"
                              :counter="50"
                              :rules="emailRules"
                              required></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 class="form-group">
                <v-text-field label="Telefone 1" type="tel" v-model="projeto.cliente.telefone1" v-mask="phoneMask"
                              :rules="phoneRules" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 class="form-group">
                <v-text-field label="Telefone 2" v-model="projeto.cliente.telefone2" v-mask="phoneMask"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 class="form-group">
                <v-text-field label="Endereço"
                              v-model="projeto.cliente.endereco"
                              :counter="50"
                              required></v-text-field>
            </v-flex>

            <v-flex d-flex xs4 sm2 class="form-group">
                <v-select :items="Array.from( estados.keys() )" label="Estado" v-model="projeto.cliente.estado" required></v-select>

            </v-flex>
            <v-flex xs8 sm4 class="form-group">
                <v-select v-if="estados && estados.get" :items="estados.get(projeto.cliente.estado)" label="Cidade" v-model="projeto.cliente.cidade" :rules="cityRules" @change="loadFiltros" required></v-select>

            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import FormHelper from '../partials/FormHelper';
    import Vue from 'vue';
    Vue.directive('mask-cpfCnpj', {
        bind(el, binding) {
            const mask = (value) => {
                const document = value.replace(/\D/g, '');
                if (document.length <= 11) {
                    return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
                } else if (document.length <= 14) {
                    return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
                }
                else {
                    return value;
                }
            };
            const input = el.querySelector('input');
            input.oninput = () => {
                input.value = mask(input.value);
            };
        },
    });

    export default {
        name: 'ProjectClient',
        components: { FormHelper },
        computed: {
            ...mapGetters(['estados']),
            projeto: {
                get() {
                    return this.$store.state.project.projeto
                },
                set(value) {
                    this.$store.commit('setProjeto', value)
                }
            }
        },
        watch: {
            "form.cidade.value": function (val) {
                this.setCidade(val)
                this.loadFiltros();
            },
            "form.estado.value": function (val) {
                this.setEstado(val)
            }
        },
        async created() {
            await this.loadEstados();
        },
        methods: {
            ...mapActions(['loadEstados', 'loadCidades', 'calculatePotencia', 'fetchSelectors', 'clearFiltros']),
            async loadFiltros() {
                this.clearFiltros();
                await this.calculatePotencia();
                this.fetchSelectors();
            },
            setCidade(val) {
                this.projeto.cliente.cidade = val;
            },
            setEstado(val) {
                this.projeto.cliente.estado = val;
            },

            validaCPF(cpf) {
                if (cpf.length != 11 ||
                    cpf == "00000000000" ||
                    cpf == "11111111111" ||
                    cpf == "22222222222" ||
                    cpf == "33333333333" ||
                    cpf == "44444444444" ||
                    cpf == "55555555555" ||
                    cpf == "66666666666" ||
                    cpf == "77777777777" ||
                    cpf == "88888888888" ||
                    cpf == "99999999999")
                    return false;

                let add = 0;

                for (let i = 0; i < 9; i++)
                        add += parseInt(cpf.charAt(i)) * (10 - i);
                let rev = 11 - (add % 11);
                if (rev == 10 || rev == 11)
                    rev = 0;
                if (rev != parseInt(cpf.charAt(9)))
                    return false;
                add = 0;
                        for (let i = 0; i < 10; i++)
                        add += parseInt(cpf.charAt(i)) * (11 - i);
                rev = 11 - (add % 11);
                if (rev == 10 || rev == 11)
                    rev = 0;
                if (rev != parseInt(cpf.charAt(10)))
                    return false;

                return true;
            },

            validaCNPJ(cnpj) {
                cnpj = cnpj.replace(/[^\d]+/g,'');
 
                if(cnpj == '') return false;
                
                if (cnpj.length != 14)
                    return false;
            
                if (cnpj == "00000000000000" || 
                    cnpj == "11111111111111" || 
                    cnpj == "22222222222222" || 
                    cnpj == "33333333333333" || 
                    cnpj == "44444444444444" || 
                    cnpj == "55555555555555" || 
                    cnpj == "66666666666666" || 
                    cnpj == "77777777777777" || 
                    cnpj == "88888888888888" || 
                    cnpj == "99999999999999")
                    return false;
                    
                let tamanho = cnpj.length - 2
                let numeros = cnpj.substring(0,tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                        pos = 9;
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(0))
                    return false;
                    
                tamanho = tamanho + 1;
                numeros = cnpj.substring(0,tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2)
                        pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(1))
                    return false;
                    
                return true;
            },
        },
        data() {
            return {
                nameRules: [
                    v => !!v || 'Nome é obrigatório',
                    v => (v && v.length <= 50) || 'Nome pode ter no máximo 50 caracteres'
                ],
                cityRules: [
                    v => !!v || 'Cidade é obrigatório',
                    v => (v && v.length <= 50) || 'Cidade pode ter no máximo 50 caracteres'
                ],
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+\..+/.test(v) || 'E-mail precisa ser válido'
                ],
                phoneRules: [
                    v => !!v || 'Telefone 1 é obrigatório',
                ],
                phoneMask: '(##) #####-####', //utilizar ['(##) ####-####','(##) #####-####'] causa loop infinito por causa do Vuex
                form: {
                    cidade: new this.$formInput(true),
                    estado: new this.$formInput(true)
                },
                cpfCnpjRules: [
                    (value) => !!value || 'Campo obrigatório',
                    (value) => {
                        if (value) {
                            const document = value.replace(/\D/g, '');
                            return (
                                this.validaCPF(document) ||
                                this.validaCNPJ(document) ||
                                'CPF ou CNPJ inválido'
                            );
                        }
                        return '';
                    },
                ],
            }
        }
    }
</script>

<style scoped>
</style>
